module.exports = __webpack_public_path__ + "static/tec-de-monterrey@2x-e0293f501e49f552560e07dc1465a717.png";